import toast from 'store/toast';

export function useToast() {
  return toast;
}
